var React = require('react');

function IconInstagramInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Zm4.115-23h-8.077A4.038 4.038 0 0 0 7 11.038v8.077a4.038 4.038 0 0 0 4.038 4.038h8.077a4.038 4.038 0 0 0 4.038-4.038v-8.077A4.038 4.038 0 0 0 19.115 7Zm.404 3.134a.5.5 0 1 0 0 1h.007a.5.5 0 1 0 0-1h-.007Zm-5.665 2.484a2.73 2.73 0 1 1 2.515 4.847 2.73 2.73 0 0 1-2.515-4.847Zm1.805-1.267a3.73 3.73 0 1 0-1.095 7.38 3.73 3.73 0 0 0 1.095-7.38Z","fill":"#fff"}));
}

IconInstagramInline.defaultProps = {"width":"30","height":"30","fill":"none"};

module.exports = IconInstagramInline;

IconInstagramInline.default = IconInstagramInline;
